/** Quem está na vitrine pública pode receber avaliação. */
export function acceptsPublicReviews(therapist?: {
  showInShowcase?: boolean;
  nomePublico?: string | null;
} | null): boolean {
  if (!therapist || therapist.showInShowcase !== true) return false;
  return Boolean(String(therapist.nomePublico || "").trim());
}
